export default __webpack_public_path__ + "static/media/P20003.fa93b65e.png";